module.exports = __webpack_public_path__ + "img/recursos-avancados.fe565b43.png";